import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleloading } from "../Store/Redux/Reducers/Dashboardreducers";
import { CatchMessage, JSONtoformdata, tokenisValid } from "../Shared/Methods";
import { DropdownService } from "../Services/ApiServices";
import { HandleSessionModal } from "../Store/Redux/Reducers/Authreducers";
import { toast } from "react-toastify";
import Loader from "../SharedComponents/Loader/Loader";
import { Col, Modal, Row } from "antd";
import classes from "./Modal.module.css";
import CommonButton from "../Components/Buttons/CommonButton";
import MeterSubscription from "../Components/Subscription/MeterSubscription";

interface props {
  item?: any;
  open: boolean;
  closable: boolean;
  onCancel: () => void;
}

function SubscriptionModal({ item, open, closable, onCancel }: props) {
  const dispatch = useDispatch();
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [DropDowns, setDropDowns] = useState({
    Meter: [],
  });
  const { loading } = useSelector((state: any) => state.Dashboard);

  // useEffect(() => {
  //   if (LoginData !== null) {
  //     getMeterDropDown();
  //   }
  // }, [LoginData]);

  const getMeterDropDown = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
    };
    DropdownService(JSONtoformdata(finalObj), "meterDropdown")
      .then(async (res) => {
        if (res?.data?.status === 1) {
          setDropDowns((pre: any) => {
            return {
              ...pre,
              Meter: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      <Loader isLoader={loading} />
      <Modal open={open} closable={closable} width={700} footer={null}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>Subscription</h4>

          {/* <Row gutter={[16, 16]} className="mb-4">
            <Col md={10} sm={12} xs={24}>
              <Commonselectfield
                labelname="Meter"
                value={item?.meter_id}
                onChange={(value) => {}}
                style={{ width: "100%" }}
                options={DropDowns?.Meter?.map((ele: any) => {
                  return { label: ele?.meter_name, value: ele?.id };
                })}
                size="large"
                name="meter_id"
              />
            </Col>
          </Row> */}

          <MeterSubscription item={item} />

          <div className={classes.modal_button_container}>
            <CommonButton
              name="Close"
              type="button"
              onClick={() => onCancel()}
              style={{ backgroundColor: "#eb3131" }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SubscriptionModal;
